import { render, staticRenderFns } from "./SendingLimitFeature.vue?vue&type=template&id=03b0969f&scoped=true&"
import script from "./SendingLimitFeature.vue?vue&type=script&lang=js&"
export * from "./SendingLimitFeature.vue?vue&type=script&lang=js&"
import style0 from "./SendingLimitFeature.vue?vue&type=style&index=0&id=03b0969f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0969f",
  null
  
)

export default component.exports